<template>
  <div>
    <div dir="rtl" v-if="lang === 'AR'">
      <p>شكرًا لاهتمامكم واستخدامكم استمارة التقديم لجي أند تي, نحن سعداء بانضمامكم إلينا.</p>
      <p>فريق خدمة العملاء لدينا سيكونون سعداء بخدمتكم وإرشادكم إلى طريقة ملئ استمارة التقديم لجي أند تي.</p>
      <h4>لخدمة التوصيل السريع يمكنكم الإتصال بنا أو إرسال بريد الكتروني لنا على:</h4>
      <h4>الإمارات العربية المتحدة:</h4>
      <p>رقم الهاتف : 800 جي أند تي (568)</p>
      <p>(من الإثنين إلى الجمعة, من 9 صباحًا إلي 6 مساءًا)</p>
      <p>(الأحد, من 10 صباحًا إلى 6 مساءًا)</p>
      <p>البريد الإلكتروني: <span>cs@jtexpress.ae</span></p>
      <h4>المملكة العربية السعودية</h4>
      <p><span>رقم الهاتف: </span>800-1010111</p>
      <p>(من السبت إلى الخميس من التاسعة صباحًا إلى السادسة مساءًا</p>
      <p>البريد الإلكتروني: <span>cs@jtexpress.sa</span></p>
    </div>
    <div v-else>
      <p>Thank you for showing interest and using the J&T application! We are excited to have you on board.</p>
      <p>Our customer service team will be happy to assist you and guide you through the registration process of your J&T application.</p>
      <h4>For Courier Service you can call us or email us on:</h4>
      <h4>United Arab Emirates:</h4>
      <p>Phone: 800 JNT (568)</p>
      <p>(Monday - Friday, 9:00 AM to 6:00 PM)</p>
      <p>(Sunday 10:00 am - 6:00 pm)</p>
      <p>Email: <span>cs@jtexpress.ae</span></p>
      <h4>Kingdom of Saudi Arabia</h4>
      <p>Phone: 800-1010111</p>
      <p>(Saturday to Thursday 9:00 am – 6:00 pm)</p>
      <p>Email: <span>cs@jtexpress.sa</span></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  computed: {
    // 国际化语言
    lang() {
      return this.$store.state.base.lang
    }
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
h4 {
  color: #333;
}
p{
  color: #666;
}
</style>
